"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERSONA_LIMITS = void 0;
/**
 * Constants related to persona limits
 */
exports.PERSONA_LIMITS = {
    MAX_PERSONAS: 12,
    LIMIT_REACHED_MESSAGE: `Maximum limit of 12 personas reached. We recommend focusing on a few well-built personas rather than many. Having fewer, more detailed personas leads to better content and more effective experiences.`,
    LIMIT_REACHED_NAME: 'PersonaLimitExceeded',
};
